export type FeatureFlags = {
  [key: string]: {
    development: boolean;
    qa: boolean;
    production: boolean;
  };
};

export const flagsConfig: FeatureFlags = {
  // IRIS-5665/IRIS-5942 - Package view in bids and cars table (combined with user permission)
  packageView: {
    development: true,
    qa: true,
    production: true,
  },
  // IRIS-6069 - Kaufempfehlung (purchase recommendation, combined with user permission)
  irisRecommendation: {
    development: true,
    qa: true,
    production: true,
  },
  // IRIS-5777 - Purchase agents (combined with user permission)
  purchaseAgent: {
    development: true,
    qa: true,
    production: true,
  },
  // IRIS-6344 - Customer mode (combined with user permission)
  customerMode: {
    development: true,
    qa: true,
    production: true,
  },
};
